// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"364":"f4f0e4d0","453":"ed08f4d2","921":"01b0403e","963":"c45bd6f3"}[chunkId] + ".chunk.js";
};